import { render } from "./AlignHorizontalLeft.vue?vue&type=template&id=53acf438"
import script from "./AlignHorizontalLeft.vue?vue&type=script&lang=js"
export * from "./AlignHorizontalLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignHorizontalLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53acf438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53acf438', __exports__)) {
    api.reload('53acf438', __exports__)
  }
  
  module.hot.accept("./AlignHorizontalLeft.vue?vue&type=template&id=53acf438", () => {
    api.rerender('53acf438', render)
  })

}


export default __exports__